module.exports = __webpack_public_path__ + "img/vw-logo.90fdc98e.svg";